import React, { useEffect, useState } from "react";

export const Intro = ({ skipIntro }) => {
    const [introVisible, setIntroVisible] = useState(true);
    const [introFade, setIntroFade] = useState(false);
    const [presentsVisible, setPresentsVisible] = useState(false);
    const [presentsFade, setPresentsFade] = useState(false);

    const [titleVisible, setTitleVisible] = useState(false);
    const [startButtonVisible, setStartButtonVisible] = useState(false);

    const animationStart = () => {
        setTimeout(function () {
            setIntroFade(true);
        }, 2500);
        setTimeout(() => {
            setPresentsVisible(true);
        }, 3250);
        setTimeout(function () {
            setPresentsFade(true);
        }, 4500);
        setTimeout(function () {
            setTitleVisible(true);
            setIntroVisible(false)
        }, 5250);
        setTimeout(function () {
            setPresentsVisible(false)
            setStartButtonVisible(true)
        }, 6500)
    }

    useEffect(() => {
        animationStart();
    }, [])

    return (
        <div id="intro" className="bg-black" onClick={skipIntro}>

            {titleVisible && <div id="end-of-intro" className={`text-center d-flex flex-column align-items-center`}>
                <div className="mt-5">
                    <div id="logo" className={`col text-center animated-slow fadeIn`}>
                        <img src="images/logo.svg" />
                    </div>
                    {startButtonVisible && <a id="splash-button" onClick={skipIntro} className={`splash-button mt-4 button text-center animated-slow slideInRight`}>Let's Get Started</a>}
                </div>
            </div>}
            {presentsVisible && <div id="presents" className={`text-center bg-black d-flex animated-slow ${presentsFade ? 'fadeOut' : 'fadeIn'}`}>
                <h1 className="my-auto mx-auto">Presents:</h1>
            </div>}
            {introVisible && <div id="animation-intro" className={`animated-slow ${introFade ? 'fadeOut' : 'fadeIn'}`}></div>}
        </div>
    )
}